import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { editorMessages } from '../messages/editorMessages';
import { PreviewFrame } from './PreviewFrame';
import { Transport } from './Transport';
import styles from './FullScreenPlayer.module.scss';

interface FullScreenPlayerProps {
  onClose: () => void;
}

/**
 * "Watch full screen" (design b1): the same live player over the whole window. Escape and Close
 * end it; the play position stays, because the master audio is the one clock.
 */
const FullScreenPlayerComponent: React.FC<FullScreenPlayerProps> = ({ onClose }) => {
  const intl = useIntl();
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className={styles.fullScreen} role="dialog" aria-modal aria-label={intl.formatMessage(editorMessages.watch)}>
      <button ref={closeRef} type="button" className={styles.fullClose} onClick={onClose}>
        {intl.formatMessage(editorMessages.fullScreenClose)}
      </button>
      <PreviewFrame fill />
      <Transport showSafe={false} wide />
    </div>
  );
};

export const FullScreenPlayer = TypedMemo(FullScreenPlayerComponent);
